import PropTypes from "prop-types";
import React from "react";
import classNames from "classnames";
import TimePicker from "react-time-picker";
import "react-time-picker/dist/TimePicker.css";
import "./TimeField.scss";

import getTestIDs from "../../../utils/getTestIDs";

export const testIDs = getTestIDs();

export class TimeField extends React.Component {
  static defaultProps = {
    defaultValue: "",
  };

  static propTypes = {
    className: PropTypes.string,
    id: PropTypes.string,
    label: PropTypes.string,
    locale: PropTypes.string,
    onChange: PropTypes.func,
    defaultValue: PropTypes.oneOfType([PropTypes.string]),
    open: PropTypes.bool,
  };

  constructor(props) {
    super(props);

    this.state = {
      value: props.defaultValue,
    };
  }

  onChange = (value) => {
    const { id, onChange } = this.props;
    this.setState({ value });

    if (onChange) {
      if (id) {
        return onChange({
          id,
          value,
        });
      }
      return onChange(value);
    }
    return value;
  };

  render() {
    const { value } = this.state;
    const { className, id, label, locale, open } = this.props;

    const fieldClass = classNames("TimeField__Container", className);

    return (
      <div className={fieldClass} data-testid={testIDs.timeFieldWrapper}>
        {label && <label htmlFor={id}>{label}</label>}
        <TimePicker
          autoComplete="off"
          data-testid={testIDs.timeField}
          disableClock
          id={id}
          locale={locale}
          onChange={this.onChange}
          open={open}
          value={value}
        />
      </div>
    );
  }
}

export default TimeField;
